import { render, staticRenderFns } from "./ColumnDetailConfig.vue?vue&type=template&id=8b4ff92a&scoped=true"
import script from "./ColumnDetailConfig.vue?vue&type=script&lang=js"
export * from "./ColumnDetailConfig.vue?vue&type=script&lang=js"
import style0 from "./ColumnDetailConfig.vue?vue&type=style&index=0&id=8b4ff92a&prod&lang=scss&scoped=true"
import style1 from "./ColumnDetailConfig.vue?vue&type=style&index=1&id=8b4ff92a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4ff92a",
  null
  
)

export default component.exports